export default {
    'delete-message-permission': 'Are you sure you want to delete this permission?'
}